import React from 'react';
import { LAYOUT } from '../../styles/constants';
import useMediaQuery from '../../hooks/useMediaQuery';

interface SectionRibbonProps {
  title: string;
}

const SectionRibbon = ({ title }: SectionRibbonProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div 
      className="relative text-white p-4 flex items-center z-10"
      style={{ 
        backgroundColor: '#0A1F87',
        width: isDesktop ? '856px' : '100%',
        height: '66px'
      }}
    >
      <h2 className="text-xl font-bold">{title}</h2>
    </div>
  );
};

export default SectionRibbon;